import { useNavigate } from "react-router-dom";
import ExportCSVButton from "../../../Components/ExportCSVButton";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { useContext, useState } from "react";
import ClearFilterButton from "../../../Components/ClearFilterButton";  
import DonationHistoryListTable from "./DonationHistoryListTable";

function DonationHistory({userType, donorId}) {


    const navigate = useNavigate();
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);

    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const [exportCsv, setexportCsv] = useState(false);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };


    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const handleExportCSV = () => {
        setexportCsv(true);
        setTimeout(() => setexportCsv(false), 0);
    }

    const [selectedRange, setSelectedRange] = useState('30 days');

    const handleDateRangeChange = (eventKey) => {
        setSelectedRange(eventKey); // Update selected date range based on user selection
    };
    return (<>

        <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-between align-items-center">
                <div style={{ marginRight: '15px' }}>
                    <h3>{userType == "donation_report" ? "Donation Reports - Filter and Exports" : "Donation History"}
                    </h3>
                </div>

                <ExportCSVButton handleExportCSV={handleExportCSV} />
                {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
           
           
            </div>
        </div>
        <>  
            <DonationHistoryListTable isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange} exportCsv={exportCsv} userType={userType} donorId={donorId} />
        </>
    </>);
}

export default DonationHistory


